export const CUSTOM_PAGINATION_ID = "custom-pagination";
